import Card from "components/card";
import DonutChart from "components/charts/DonutChart";
import Loader from "components/loader";
import usePublications from "hooks/usePublications";
import { useEffect, useState } from "react";
import { DASHBOARD_COLORS } from "utils/dashboardColors";

const donutOptions = {
  chart: {
    type: "donut",
  },
  labels: ["Espontáneas", "Directas"],
  colors: [DASHBOARD_COLORS.varios, DASHBOARD_COLORS.otros],
  legend: {
    show: true,
    position: "bottom",
  },
  dataLabels: {
    enabled: true,
  },
  tooltip: {
    theme: "dark",
  },
};

const PostulationsBreakdownChart = () => {
  const { getPostulatedsCount } = usePublications();
  const [isLoading, setIsLoading] = useState(false);
  const [stats, setStats] = useState({ total: 0, espontaneas: 0, directas: 0 });

  const fetchStats = async () => {
    setIsLoading(true);
    const data = await getPostulatedsCount();
    setStats({
      total: Number(data?.postulaciones || 0),
      espontaneas: Number(data?.espontaneas || 0),
      directas: Number(data?.directas || 0),
    });
    setIsLoading(false);
  };

  useEffect(() => {
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card extra="w-full h-[460px] px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          Postulaciones: espontáneas vs directas
        </div>
        <p className="text-sm font-semibold text-gray-600">
          {isLoading ? <Loader small={true} /> : `${stats.total} totales`}
        </p>
      </div>

      <div className="mt-4 flex h-[380px] w-full items-center justify-center">
        {isLoading ? (
          <Loader />
        ) : (
          <DonutChart options={donutOptions} series={[stats.espontaneas, stats.directas]} />
        )}
      </div>
    </Card>
  );
};

export default PostulationsBreakdownChart;
